var exports = {
  "wx": "PremiumBadgeSettings.module__header___N0dqcD",
  "DD": "PremiumBadgeSettings.module__title___N0dqcD",
  "h_": "PremiumBadgeSettings.module__description___N0dqcD",
  "n$": "PremiumBadgeSettings.module__switches___N0dqcD",
};

module.exports = exports;
